import { FC, useState } from 'react'
import { defaultTheme, Icons, Progress } from '@agro-club/agroclub-shared'
import { useTranslation } from 'react-i18next'
import { APopoverButton } from 'views/components/Analytics/APopoverButton'
import { PopoverContainer } from 'views/styled/common'
import { ASharedModal, SharedModalContent, SharedModalTitle } from '../SharedModal'
import ADefaultModalFooter from '../DefaultModalFooter/ADefaultModalFooter'
import styled from 'styled-components'

type Props = {
  //bid: USBid
  setPopoverVisible: (arg: boolean) => void
  onClickEdit: () => void
  onUnpin: () => void
  unpinProgress: Progress
}

const OutlinedStar = styled(Icons.IconStarOutline)`
  path {
    fill: none !important;
    stroke: ${defaultTheme.color.textPrimary900};
  }
`

export const CommentPopoverContent: FC<Props> = ({ setPopoverVisible, onClickEdit, onUnpin, unpinProgress }) => {
  const { t } = useTranslation('comments')
  const [isConfirmVisible, setIsConfirmVisible] = useState(false)

  return (
    <PopoverContainer
      width={170}
      onClick={(e) => {
        e.stopPropagation()
        setPopoverVisible(false)
      }}
    >
      <APopoverButton id="edit" onClick={onClickEdit} Icon={<Icons.IconEdit />} text={t('common:edit')} />

      <APopoverButton id="unpin" onClick={() => setIsConfirmVisible(true)} Icon={<OutlinedStar />} text={t('unpin')} />

      {isConfirmVisible && (
        <ASharedModal id="confirmUnPin" onClose={() => setIsConfirmVisible(false)} size="small">
          <SharedModalTitle>{t('unpinСomment')}</SharedModalTitle>
          <SharedModalContent>{t('unpinСommentText')}</SharedModalContent>
          <ADefaultModalFooter
            progress={unpinProgress}
            onClose={() => setIsConfirmVisible(false)}
            onConfirm={onUnpin}
          />
        </ASharedModal>
      )}
    </PopoverContainer>
  )
}
